import { Table, type TableProps } from '@mui/material';
import { forwardRef } from 'react';

import type { ExtraProps } from './types.js';
import { colors } from '../../theme';

export const MarkdownTable = forwardRef<HTMLTableElement, TableProps & ExtraProps>((props, ref) => {
  const { node, ...rest } = props;
  return (
    <Table
      {...rest}
      ref={ref}
      sx={{
        border: '1px solid',
        borderColor: colors.border.light,
        '& thead': {
          backgroundColor: colors.background.default,
        },
        '& th, td': {
          paddingX: 1,
          paddingY: 0.5,
          '& +th,+td': {
            borderLeft: '1px solid',
            borderColor: colors.border.light,
          },
          fontSize: (theme) => theme.typography.body2.fontSize,
        },
      }}
    />
  );
});
MarkdownTable.displayName = 'MarkdownTable';
